module.exports = __webpack_public_path__ + "img/m1.525f379b.png";